import { render, staticRenderFns } from "./AppTopItem.vue?vue&type=template&id=b6dcb5de&scoped=true"
import script from "./AppTopItem.vue?vue&type=script&lang=ts"
export * from "./AppTopItem.vue?vue&type=script&lang=ts"
import style0 from "./AppTopItem.vue?vue&type=style&index=0&id=b6dcb5de&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6dcb5de",
  null
  
)

export default component.exports